import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { LabTestCategoryModel } from '../../../models/master-data/labtest-category.model';
import { LabTestDataModel } from '../../../models/master-data/lab-test-data.model';
import { LabTestUrl } from '../../../shared/urls/master-data.labtest.url';
import { LabTestCategoryUrl } from '../../../shared/urls/master-data.labtest-category.url';
import { Utility } from '../../../common/utility';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';

@Injectable()
export class GroupRecommendedLabTestService {
  constructor(private baseService: BaseService) {

  }

  getRecommendLabTest(groupId): any {
    let url = Utility.stringFormat(ConsultationUrl.RECOMMEND_LABTEST, [groupId]);
    return this.baseService.getData(url);
  }

  getLabTestsCategories(): any {
    let url = LabTestCategoryUrl.LABTESTCATEGORY_GET_DROP_DOWN_LIST;
    return this.baseService.getData(url);
  }

  getLabTests(categoryId, showPinner = true): any {
    let url = Utility.stringFormat(LabTestUrl.LABTEST_GET_CENTRE, [categoryId]);
    return this.baseService.getData(url, { isHasPrice: true }, showPinner);
  }

  quickSearchLabTest(searchKey, showPinner = true) {
    const param = {
      name: searchKey,
      isHasPrice: true
    };
    const url = LabTestUrl.LABTEST_GET_BY_NAME;
    return this.baseService.getData(url, param, showPinner);
  }

  updateLabTest(groupId, data, isMoveNextStep) {
    let url = Utility.stringFormat(ConsultationUrl.RECOMMEND_LABTEST, [groupId]);
    url += '?isMoveNextStep=' + isMoveNextStep;
    return this.baseService.postData(url, data);
  }
  // getCategoryList() {
  //   return categoryList;
  // }

  // getLabTestListByCategoryId(categoryId: string): Array<LabTestDataModel> {
  //   return labTestDataList.filter(x => x.labTestCategoryId === categoryId);
  // }

}

// const categoryList: Array<LabTestCategoryModel> = [
//   {
//     id: '1',
//     name: 'test 1',
//     description: 'test 1'
//   },
//   {
//     id: '2',
//     name: 'test 2',
//     description: 'test 2'
//   },
//   {
//     id: '3',
//     name: 'test 3',
//     description: 'test 3'
//   }
// ];

// const labTestDataList: Array<LabTestDataModel> = [
//   {
//     id: 'c1',
//     name: 'test content 1',
//     screenType: '',
//     priority: '',
//     description: "no test",
//     labTestCategoryName: '1',
//     labTestCategoryId: '1',
//   },
//   {
//     id: 'c2',
//     name: 'test content 2',
//     screenType: '',
//     priority: '',
//     description: "no test",
//     labTestCategoryName: '2',
//     labTestCategoryId: '1',

//   },
//   {
//     id: 'c3',
//     name: 'test content 3',
//     screenType: '',
//     priority: '',
//     description: "no test",
//     labTestCategoryName: '1',
//     labTestCategoryId: '1',
//   },
//   {
//     id: 'c4',
//     name: 'test content 4',
//     screenType: '',
//     priority: '',
//     labTestCategoryName: '1',
//     description: "no test",
//     labTestCategoryId: '2',
//   },
//   {
//     id: 'c5',
//     name: 'test content 5',
//     screenType: '',
//     priority: '',
//     labTestCategoryName: '3',
//     description: "no test" ,
//     labTestCategoryId: '3',
//   }
// ];



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/group-recommended-lab-tests/group-recommended-lab-tests.service.ts